import WG from '../../common/modules/wg';

function toggleHistory(event) {
    const $list = $('.history__list');
    const $button = $(event.target);
    const classOpened = 'history__list--opened';
    const textLess = $button.data('less');
    const textMore = $button.data('more');
    const isOpened = $list.hasClass(classOpened);

    if (isOpened) {
        $list.removeClass(classOpened);
        $button.text(textMore);
    } else {
        $list.addClass(classOpened);
        $button.text(textLess);
    }
}

function initHistoryToggler() {
    $('.history__button').on('click', toggleHistory);
}

function playVideo() {
    const $videoElem = $('.video');
    const youtubeId = $videoElem.data('youtube-id');
    const htmlIframe = `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${youtubeId}?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>`;
    let isIframeAppended = false;

    if (!$videoElem.length) {
        return false;
    }

    $videoElem.on('click', () => {
        if (isIframeAppended === false) {
            WG.GdprUserCentrics.makeConditionalCallback(() => {
                $videoElem.addClass('playing');
                $videoElem.append(htmlIframe);
                isIframeAppended = true;
            }, WG.GdprUserCentrics.ConsentCategories.Advertising)();
        }
    });
}

function main() {
    initHistoryToggler();
    playVideo();
}

$(main);



// WEBPACK FOOTER //
// ./assets/js/projects/company/company.js